import { render, staticRenderFns } from "./extre_raporu.vue?vue&type=template&id=64a0f836&"
import script from "./extre_raporu.vue?vue&type=script&lang=js&"
export * from "./extre_raporu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports